module.exports = __webpack_public_path__ + "img/logo.3c31dae4.png";